import { QuestionType2UIConfig } from "../../../../../components/ui/question-type2-ui";
import { GeneralQuestionUIConfig, GeneralQuestionUIConfigOption } from "../../../../../cvp-webgames-core/Components/ui/react/core-general-question-ui";
import BaseScenarioPart from "../../../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { ScoringType } from "../../../../../misc/tools";
import { GameBaseScenario } from "../../../../GameBaseScenario";
import { scenario7TransfusionAudioCaching, scenario7TransfusionVideoSegments } from "../../../Scenario7-transfusion";
import { TransfusionComponentsStep2ComponentPart1Config, TransfusionComponentsStep2ComponentMainConfig } from "../transfusion-components-step2";

export default class TransfusionComponentsStep2Part1 extends BaseScenarioPart<GameBaseScenario> {

	private stepName="Step 3"
	private get config(): TransfusionComponentsStep2ComponentPart1Config {
		return this.mainConfig.part1Config;
	}
	constructor(scenario: GameBaseScenario, private onDone: () => void, private id: string, private mainConfig: TransfusionComponentsStep2ComponentMainConfig) {
		super(scenario);
	}

	public get partId(): string {
		return this.id;
	}

	public get videoUrl(): string[] {
		return [this.config.videoUrl];
	}

	public start() {
		this.section1();
	}

	public section1() {
		const context = this;
		this.mainConfig.scenario.uiWrapper.displayQuestonType2UI({
			audioUrl: scenario7TransfusionAudioCaching.getItemByKey(scenario7TransfusionAudioCaching.audioKeys.question5).src,
			title: this.mainConfig.scenario.props.name,
			subtitle: this.stepName,
			isYesCorrect: false,
			correctFeedback: `
				<p class="default-text">Correct. There is no history involving this type of behavior or decision making with this employee.</p>
			`,
			wrongFeedback: `
				<p class="default-text">This is not the best option. Nurse Becky has not previously been involved in a similar incident.</p>
			`,
			question: 'Were there repetitive occurrences with this type of behavior involving the employee?',
			onSubmitClicked: (isCorrect: boolean, feedback: string, selectedTitle: string, parentQuestion: QuestionType2UIConfig) => {
				const mentorInfo = scenario7TransfusionVideoSegments.getItemByKey('Feedback');
				context.scenario.onChoiceSubmittedQuestionType2(isCorrect, feedback, selectedTitle, this.stepName, parentQuestion, () => {
					context.section2();
				}, () => {
					context.section2();
				}, undefined, undefined, undefined, mentorInfo.src, mentorInfo.chapterIds[11], mentorInfo.chapterIds[12]);
			}
		},4);
	}

	public section2() {
		const context = this;
        this.mainConfig.scenario.setAreaForCurrentScenario(5);
		this.mainConfig.scenario.uiWrapper.displayIntroScreenUI({
			title: 'Re-Cap Summary Statement',
			subtitle: 'Scenario 7 - Transfusion',
			recapFirst: 'In summary this is “Reckless Behavior.” ',
			htmlData: `
				<br/><li>The substitution test is NOT satisfied. 
				<br/><br/></li><li>Accountability lies solely with the employee in this instance. 
				<br/><br/></li><li>There is no history involving this type of behavior with the employee. 
				<br/><br/></li><li>Discipline may be warranted. 
				<br/><br/></li><li>Console and coach the employee.</li>
			`,
			okButton: 'Continue',
			onStartScenarioClicked: () => {
				context.onDone();
			},
			mentorUrl: scenario7TransfusionVideoSegments.getItemByKey('Feedback').src,
			mentorChapter: scenario7TransfusionVideoSegments.getItemByKey('Feedback').chapterIds[14]
		})
	}
}